import { TimeFormat } from "types";
import { TIME_FORMAT_H12, TIME_FORMAT_H24 } from "shared-constants";

export const timeFormatToMomentTimeFormat = (timeFormat: TimeFormat): string =>
  timeFormat === TimeFormat.TWELVE_HOUR ? TIME_FORMAT_H12 : TIME_FORMAT_H24;
